import { Facebook } from "../../assets/Facebook";
import { InstagramIcon } from "../../assets/InstagramIcon";
import { Tiktok } from "../../assets/Tiktok";

type Icons = "instagram" | "facebook" | "tiktok";

const SOCIALMEDIA_ICONS = (iconName: Icons, iconClassName?: string) => {
  switch (iconName) {
    case "instagram":
      return (
        <InstagramIcon className={`${iconClassName ? iconClassName : "w-7"}`} />
      );
    case "facebook":
      return (
        <Facebook className={`${iconClassName ? iconClassName : "w-7"}`} />
      );
    case "tiktok":
      return <Tiktok className={`${iconClassName ? iconClassName : "w-8"}`} />;
    default:
      <></>;
  }
};

interface Props {
  icon: Icons;
  link: string;
  text?: string;
  iconClassName?: string;
  className?: string;
}
export const SocialMediaLink = ({
  icon,
  text,
  link,
  className,
  iconClassName
}: Props) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className={`flex hover:text-white text-gray-400 ${className}`}
    >
      {SOCIALMEDIA_ICONS(icon, iconClassName)}
      {text ? <span className="text-sm ml-1">{text}</span> : <></>}
    </a>
  );
};
